import React, {useContext, useEffect, useState} from 'react';
import Styles from "../styles/pages/SongViewer.module.css";
import {transposeChord, renderChordLine} from "../helpers/SongFunctions"
import {isUserInRole, load_fetch} from "../pr_utils";
import {Navigate, useLocation, useNavigate} from "react-router-dom";
import {AuthContext} from "../AuthContext";


const ChordAndLyricsDisplay = () => {
    const [chordData, setChordData] = useState([]);
    const [lyrics, setLyrics] = useState(false);
    const [transposition, setTransposition] = useState(0);
    const [capo, setCapo] = useState(0);
    const { search } = useLocation();
    const queryParams = new URLSearchParams(search);
    const [songId, setSongId] = useState(false);
    const [sections, setSections] = useState([]);
    const [songInfo, setSongInfo] = useState([]);
    const [serviceId, setServiceId] = useState(false);
    const { authStatus } = useContext(AuthContext);
    const navigate = useNavigate();

    useEffect(() => {
        setSongId(queryParams.get("song_id"));
        if(queryParams.has("service_id")) {
            setServiceId(queryParams.get("service_id"));
        }

        setChordData([
            [
                {chord:"A", position: 8},
                {chord:"D", position: 14},
                {chord:"A", position: 24},
                ],
            [
                {chord:"A", position: 7},
                {chord:"E", position: 15},
                {chord:"A", position: 22},
            ],
            [
                {chord:"E", position: 8},
                {chord:"A", position: 22},
            ],
            [
                {chord:"E", position: 9},
                {chord:"A", position: 28},
            ],
            [
                {chord:"D", position: 14},
                {chord:"A", position: 21},
            ],
            [
                {chord:"A", position: 10},
                {chord:"E", position: 20},
                {chord:"A", position: 28},
            ],
        ]);

        setLyrics([
            "Rock of Ages, cleft for me,",
            "Let me hide myself in Thee;",
            "Let the water and the blood,",
            "From Thy wounded side which flowed,",
            "Be of sin the double cure,",
            "Save from wrath and make me pure."
        ]);
    }, [])

    useEffect(() => {
        fetchSongInfo(songId);
        fetchSongSections(songId);
    }, [songId]);

    const fetchSongSections = () => {
        load_fetch(
            "handlers/Service_Handler.php",
            {operation:"FETCH_SONG_SECTIONS", songId:songId},
            (data) => {
                if(!data['ERROR'] && !data['error']) {
                    console.log(data);
                    setSections(data);
                }
            }
        )
    };

    const fetchSongInfo = (songId) => {
        load_fetch(
            "handlers/Service_Handler.php",
            {operation:"FETCH_SONG_INFO", songId:songId},
            (data) => {
                if(!data['SUCCESS'] === false) {
                    console.log(data);
                    setSongInfo(data['DATA']);
                }
            }
        )
    };


    const transposeChordData = (chordsToTranspose) => {
        if(!chordsToTranspose.length) return;

        let transposedChords = [];

        for(let i = 0; i < chordsToTranspose.length; i++) {
            let chordLine = chordsToTranspose[i];
            let newChordLine = [];
            for(const {chord, position} of chordLine) {
                newChordLine.push({chord: transposeChord(chord, transposition - capo), position: position});
            }
            transposedChords.push(newChordLine);
        }
        console.log(transposedChords);
        return transposedChords;
    }
    const decrementTransposition = () => {
        setTransposition(transposition - 1);
    }
    const incrementTransposition = () => {
        setTransposition(transposition + 1);
    }
    const decrementCapo = () => {
        if(capo === 0) {
            return;
        }
        setCapo(capo - 1);
    }
    const incrementCapo = () => {
        setCapo(capo + 1);
    }
    useEffect(() => {
        console.log("Transposing by " + transposition);
        //transposeChordData();
        //renderSections();
    }, [transposition]);



    const renderChords = () => {
        // Create local copy
        let localChords = JSON.parse(JSON.stringify(chordData));

        // Transpose if necessary
        if(transposition) {
            localChords = transposeChordData();
        }

        let output = "";
        for (let i = 0; i < lyrics.length; i++) {
            output += renderChordLine(localChords[i]) + "\n";
            output += lyrics[i] + "\n";
        }

        console.log(output);

        return output;
    }


    const renderSection = (section) => {
        let output = "";

        // Create local copy of chords
        let localChords = JSON.parse(section.chords_data);

        // Transpose if necessary
        if(transposition || capo) {
            localChords = transposeChordData(localChords);
        }

        let lyricsData = JSON.parse(section.lyrics_data);

        for (let j = 0; j < lyricsData.length; j++) {
            output += renderChordLine(localChords[j]) + "\n";
            output += lyricsData[j] + "\n";
        }

        return output;
    }

    const navigateBackToService = () => {
        navigate("../service_planner?sid=" + serviceId);
    }
    const navigateToEditor = () => {
        navigate("../chords_editor?song_id=" + songId);
    }



    return <>

        {/* SONG INFO */}
        <div className={Styles.songInfoHeader}>
            <h1>
                {songInfo?.title}
                <button
                    className={serviceId ? `${Styles.noPrint} ${Styles.navButton}` : Styles.hidden}
                    onClick={navigateBackToService}
                >Back to Service</button>

                {/* Block unauthenticated users or non-admins */}
                {isUserInRole(authStatus, ['ADMIN']) || isUserInRole(authStatus, ['SERVICE_EDITOR']) ?
                    (
                        <button
                            className={`${Styles.noPrint} ${Styles.navButton}`}
                            onClick={navigateToEditor}
                        >Edit</button>
                    ) : ''}
            </h1>
            <div className={Styles.songNotes}>{songInfo?.notes}</div>
        </div>

        {/* MODIFICATION BUTTONS */}
        <div className={Styles.modificationControls}>
            <button
                onClick={decrementTransposition}
                className={Styles.transposeButton}
            >&lt;</button> Transpose: {transposition}&nbsp;
            <button
                onClick={incrementTransposition}
                className={Styles.transposeButton}
            >&gt;</button>
            <button
                onClick={decrementCapo}
                className={Styles.capoButton}
            >&lt;</button> Capo On: {capo}&nbsp;
            <button
                onClick={incrementCapo}
                className={Styles.capoButton}
            >&gt;</button>
        </div>

        {/* SONG DISPLAY */}
        {sections.length > 0 && sections.map((section, index) => (
            <div className={Styles.sectionHolder} key={index}>
                <div className={Styles.sectionDisplay}>
                    <h3>{section.section_title}</h3>
                    <pre
                        className={Styles.chordViewer}
                    >
                        {renderSection(section)}
                    </pre>
                </div>
                <div className={Styles.sectionNotes}>
                    {section.section_notes.split('\n').map((note, index) => (
                        <div key={index}>{note}</div>
                    ))}
                </div>
            </div>
        ))}

        {/* MODIFICATION BUTTONS */}
        <div className={`${Styles.modificationControls} ${Styles.noPrint}`}>
            <button
                onClick={decrementTransposition}
                className={Styles.transposeButton}
            >&lt;</button> Transpose: {transposition}&nbsp;
            <button
                onClick={incrementTransposition}
                className={Styles.transposeButton}
            >&gt;</button>
            <button
                onClick={decrementCapo}
                className={Styles.capoButton}
            >&lt;</button> Capo On: {capo}&nbsp;
            <button
                onClick={incrementCapo}
                className={Styles.capoButton}
            >&gt;</button>
        </div>
    </>
}

export default ChordAndLyricsDisplay;